import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';
import { isInnermostList } from '../../extensions/nested_lists';

export const OrderedListButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: isInnermostList(editor.state, 'orderedList'),
      isDisabled: !editor.can().toggleOrderedList(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleOrderedList().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="list-ol" />}
         title={_js('Add a numbered list')}
         shortcut={'shift+7'}
      />
   );
};
